export function processProgramNotes(module, mapContainer) {
  let programNoteTitle = mapContainer.find('h2:contains("Program Note")').first();

  if (!programNoteTitle.length) {
    return;
  }

  let parentElement = programNoteTitle.parent();
  let otherChildren = parentElement.children().not(programNoteTitle);

  if (!otherChildren.length) {
    module.hide();
    return;
  }

  let programNoteDataContainer = module.find(".js-programNotesData");
  programNoteDataContainer.html(otherChildren.html());
}